<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	import { Datepicker } from 'svelte-calendar';
	import datepickerStore from 'svelte-calendar/stores/datepicker';
	import { tick } from 'svelte';
	// Constants
	import { theme } from '@/Constants/DatePicker.js';
	// Components
	import Icon from '@/Components/Icon.svelte';

	export let selected = dayjs().toDate();
	export let start = dayjs().subtract(24, 'month').toDate();
	export let end = dayjs().add(24, 'month').toDate();
	export let format = 'YYYY-MM-DD';
	export let displayFormat = format;
	export let formatted = '';
	export let dateChosen;
	export let btnStyle =
		'p-2.5 rounded border border-gray-300 hover:bg-grey-400 focus:outline-none bg-white min-w-[110px] ';
	export let appendBtnStyle = '';
	export let disabled = false;
	export let height = '41px';

	selected = dayjs(selected).toDate();

	let store = datepickerStore.get({
		selected,
		start,
		end,
		shouldEnlargeDay: false,
		startOfWeekIndex: 0
	});

	dayjs.extend(localizedFormat);

	store.subscribe((current) => {
		if (current.hasChosen && current.selected) {
			if (!dayjs(selected).isSame(dayjs(current.selected))) {
				selected = current.selected;
			}
			fireDateChosen();
		}
	});

	async function fireDateChosen() {
		await tick();
		if (typeof dateChosen === 'function') dateChosen(selected);
	}
</script>

<Datepicker bind:start bind:end bind:selected bind:formatted {format} {theme} let:key let:send let:receive bind:store>
	<button
		type="button"
		in:receive|local={{ key }}
		out:send|local={{ key }}
		class={btnStyle + ' ' + appendBtnStyle}
		style:height={`${height}`}
		class:opacity-50={disabled}
		{disabled}
	>
		<slot>
			<div class="flex flex-row items-center justify-center whitespace-nowrap text-nowrap">
				{dayjs(selected).format(displayFormat ?? format)}
				<Icon name="calendar" classes="w-4 h-4 ml-2 mr-0.5" />
			</div>
		</slot>
		{#if disabled}
			<span
				role="button"
				aria-pressed="false"
				tabindex="0"
				class="absolute inset-0 overflow-y-auto z-20 cursor-not-allowed"
				on:click|stopPropagation|preventDefault
				on:keyup|stopPropagation|preventDefault
			/>
		{/if}
	</button>
</Datepicker>
